import { Flex, Icon, Heading, Text, Button } from '@chakra-ui/react';
import { AiOutlineCloseCircle, AiOutlineReload } from 'react-icons/ai/index.js';

interface FileTrackerErrorProps {
  reloadFn?: () => void;
  errorMsg?: string;
}
export const FileTrackerError = (props: FileTrackerErrorProps) => {
  const { reloadFn, errorMsg } = props;
  return (
    <Flex direction={'column'} align='center'>
      <Icon
        as={AiOutlineCloseCircle}
        sx={{
          fontSize: '50px',
          m: 2,
          color: 'red.500',
        }}
      />
      <Heading fontSize={'md'} color={'red.500'}>
        Unexpected Error
      </Heading>
      <Text m={2}>
        {' '}
        {errorMsg
          ? errorMsg
          : 'We encountered an unexpected error. Please try again'}
      </Text>
      <Button
        colorScheme={'blue'}
        size={'sm'}
        onClick={() => reloadFn && reloadFn()}
        leftIcon={<Icon as={AiOutlineReload} fontSize='md'></Icon>}
      >
        Try Again
      </Button>
    </Flex>
  );
};
